import React, { useState } from 'react';
import { PageHeading, SectionHeading } from 'web-ui-components/lib/typography/headings';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { WebsiteLink } from 'web-ui-components/lib/actions/links';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import { GenericAccordion } from 'web-ui-components/lib/layout/content';
import PropTypes from '../../types';
import { Content } from '../../infrastructure/content';
import { getHyperlink } from '../../utils';

const PrimaryApplicantWaitingPage = ({ bankId, onEditButtonClick }) => {
  const [expandedIds, setExpendedIds] = useState([]);
  return (
    <div>
      <Content>
        {({
          referPageTitle = '',
          referContentA,
          referContentB,
          referContentC,
          referContentD,
          referContentE,
          referContentG,
          referContentH,
          referContentJ,
          referContentK,
          editApplicationLinkText,
          moreBusinessProductLinkText,
          moreBusinessProductLinkYB,
          moreBusinessProductLink
        }) => (
          <div>
            <PageHeading>{referPageTitle} </PageHeading>
            <StandardBody>
              <p>{referContentA}</p>
              <p>{referContentB}</p>
            </StandardBody>
            <SectionHeading heading2={referContentC} />
            <div className="u-margin-bottom-2">
              <GenericAccordion
                expandedIds={expandedIds}
                onClick={newExpendedIds => setExpendedIds(newExpendedIds)}
                items={[
                  {
                    contentNode: (
                      <StandardBody>
                        <p>{referContentE}</p>

                        <div>
                          <WebsiteLink
                            linkText={moreBusinessProductLinkText}
                            willOpenNewWindow
                            url={getHyperlink(
                              moreBusinessProductLink,
                              moreBusinessProductLinkYB,
                              bankId
                            )}
                          />
                        </div>
                      </StandardBody>
                    ),
                    heading: referContentD,
                    id: '1'
                  },
                  {
                    contentNode: (
                      <StandardBody>
                        <p>{referContentH}</p>
                        <NavigationButton.Tertiary
                          labelText={editApplicationLinkText}
                          onClick={onEditButtonClick}
                        />
                      </StandardBody>
                    ),
                    heading: referContentG,
                    id: '2'
                  },
                  {
                    contentNode: (
                      <StandardBody>
                        <p>{referContentK}</p>
                        <WebsiteLink
                          linkText={moreBusinessProductLinkText}
                          willOpenNewWindow
                          url={getHyperlink(
                            moreBusinessProductLink,
                            moreBusinessProductLinkYB,
                            bankId
                          )}
                        />
                      </StandardBody>
                    ),
                    heading: referContentJ,
                    id: '3'
                  }
                ]}
              />
            </div>
          </div>
        )}
      </Content>
    </div>
  );
};

PrimaryApplicantWaitingPage.propTypes = {
  bankId: PropTypes.bankId.isRequired
};

export default PrimaryApplicantWaitingPage;
